// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__19rwG","title":"Images90_title__Tpz-a","images":"Images90_images__3vjYU"};